module.exports = __webpack_public_path__ + "static/media/The_Core_Four_C.5f3efb4e.png";